export default {
    binEditor: {
        dstBanner: {
            spring: 'Začne se poletni čas. Ta dan ima 92 intervalov (ura se premakne naprej 02:00 → 03:00).',
            autumn: 'Konča se poletni čas. Ta dan ima 100 intervalov (ura se premakne nazaj 03:00 → 02:00).',
        },
        dayPosition: 'Dan {current} od {total}',
        binsLabel: 'Intervali',
        binCount: {
            spring: '{count} (DST premik naprej)',
            autumn: '{count} (DST premik nazaj)',
            normal: '{count} (normalno)',
        },
        daySum: 'Vsota dneva',
        dirty: 'neshranjeno',
        copyDay: 'Kopiraj ta dan na druge dneve...',
        resetDay: 'Ponastavi dan',
    },
}
